import { render, staticRenderFns } from "./DataTable4.vue?vue&type=template&id=c72182f8&scoped=true"
import script from "./DataTable4.vue?vue&type=script&lang=js"
export * from "./DataTable4.vue?vue&type=script&lang=js"
import style0 from "./DataTable4.vue?vue&type=style&index=0&id=c72182f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72182f8",
  null
  
)

export default component.exports